import { useState, useEffect } from "preact/hooks";

const BREAKPOINTS = [
    { name: 'desktop', query: '(min-width: 66.001em)' },
    { name: 'tablet', query: '(min-width: 33.001em) and (max-width: 66em)' },
    { name: 'mobile', query: '(max-width: 33em)' },
]


export const useBreakpoints = () => {

    const [screen, setScreen] = useState('')
    const [isDesktop, setIsDesktop] = useState(false)
    const [isTablet, setIsTablet] = useState(false)
    const [isMobile, setIsMobile] = useState(false)


    const handleMediaChange = (media) => {
        if (media.matches) {
            const breakpoint = BREAKPOINTS.find(breakpoint => breakpoint.query === media.media)
            if (breakpoint) {
                setScreen(breakpoint.name)
                if (breakpoint.name === 'desktop') {
                    setIsDesktop(true)
                    setIsTablet(false)
                    setIsMobile(false)
                } else if (breakpoint.name === 'tablet') {
                    setIsDesktop(false)
                    setIsTablet(true)
                    setIsMobile(false)
                } else if (breakpoint.name === 'mobile') {
                    setIsDesktop(false)
                    setIsTablet(false)
                    setIsMobile(true)
                }
            }
        }
    }

    useEffect(() => {

        let mediaQueries = []

        BREAKPOINTS.forEach(breakpoint => {
            const mediaQuery = window.matchMedia(breakpoint.query);
            handleMediaChange(mediaQuery)
            mediaQuery.addEventListener('change', handleMediaChange)
            mediaQueries = [...mediaQueries, mediaQuery]
        })

        return () => {
            mediaQueries.forEach(mediaQuery => mediaQuery.removeEventListener('change', handleMediaChange))
        }

        
    }, []);


    return {
        screen,
        isMobile,
        isTablet,
        isDesktop
    }
}